import { ReactNode, useCallback, useState } from 'react';
import { Document, Page } from 'react-pdf';
import { OnDocumentLoadSuccess } from 'react-pdf/dist/esm/shared/types.js';
import { cn, Stack } from '@prenuvo/halo';

import { OPTIONS } from './pdf-viewer.constant';

interface PdfViewerDocumentProps {
  error?: ReactNode;
  loading?: ReactNode;
  renderTextLayer: boolean;
  url: string;
  width: number | undefined;
}

export function PdfViewerDocument({
  error,
  loading,
  renderTextLayer,
  url,
  width,
}: PdfViewerDocumentProps) {
  const [numPages, setNumPages] = useState(0);
  const [isDocumentLoadSettled, setIsDocumentLoadSettled] = useState(false);

  const handleDocumentLoadSuccess: OnDocumentLoadSuccess = useCallback((doc) => {
    setNumPages(doc.numPages);
    setIsDocumentLoadSettled(true);
  }, []);

  return (
    <Stack
      className={cn(
        'pdf-viewer-scroll-area isolate min-h-0 flex-1 overflow-x-hidden overflow-y-auto overscroll-y-contain contain-[paint]',
        {
          'opacity-0': !isDocumentLoadSettled,
          'pdf-viewer-view-only': !renderTextLayer,
        },
      )}
    >
      <Document
        error={error}
        file={url}
        loading={loading}
        onLoadError={() => setIsDocumentLoadSettled(true)}
        onLoadSuccess={handleDocumentLoadSuccess}
        options={OPTIONS}
      >
        {width
          ? Array.from(new Array(numPages), (_, index) => (
              <Page
                key={`page_${index + 1}`}
                className="w-full max-w-full"
                pageNumber={index + 1}
                renderAnnotationLayer={renderTextLayer}
                renderTextLayer={renderTextLayer}
                width={width}
              />
            ))
          : null}
      </Document>
    </Stack>
  );
}
